import gql from "graphql-tag";

export default gql`
  query GetMyAccess {
    getMyAccess {
      tenantId
      objectId
      permissions
      version
    }
  }
`;